"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onChangeHandler = void 0;
var onChangeHandler = function (e) {
    var value = e.target.value;
    value = value.replace(/[^0-9:]/g, '');
    if (value.length > 2 && value[2] !== ':') {
        value = value.slice(0, 2) + ':' + value.slice(2);
    }
    if (value.length > 5) {
        value = value.slice(0, 5);
    }
    if (value.length >= 1) {
        var firstHourDigit = value[0];
        if (firstHourDigit > '2') {
            value = '';
        }
    }
    if (value.length >= 2) {
        var hours = value.slice(0, 2);
        if (hours[0] === '2' && hours[1] > '3') {
            value = value.slice(0, 1);
        }
    }
    if (value.length >= 4) {
        var firstMinuteDigit = value[3];
        if (firstMinuteDigit > '5') {
            value = value.slice(0, 3);
        }
    }
    return (e.target.value = value);
};
exports.onChangeHandler = onChangeHandler;
